export default "__VITE_ASSET__I$LM87wA__"